module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice Number",
            "field": "number",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isPlanned && !_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Reference",
            "field": "document_reference",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Contract/Student",
            "field": "contract_id",
            "optionListApiUrl": '/contracts/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Year",
            "field": "year",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Semester",
            "field": "semester",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || (_vm.isEdit && !_vm.isPlanned),
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Linked to",
            "field": "linked_invoice_number",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice Date",
            "field": "invoice_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Date",
            "field": "planned_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": _vm.isPlanned ? 'required' : 'ok',
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Expiration Date",
            "field": "expiration_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Extended Deadline Date",
            "field": "extended_deadline_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount to be paid",
            "field": "amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || _vm.isLocked(),
            "type": "money",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (_vm.isReadOnly) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount invoiced",
            "field": "total_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [(!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount paid",
            "field": "payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Pro Forma",
            "field": "pro_forma",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "PDF Creation",
            "field": "pdf_creation_timestamp",
            "field2": "pdf_creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Email",
            "field": "email_timestamp",
            "field2": "email_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isPlanned && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createPDF(props.rec)
            }
          }
        }, [_vm._v("Create Invoice")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadPDF(props.rec)
            }
          }
        }, [_vm._v("Download " + _vm._s(_vm.isCreditNote ? 'Credit Note' : 'Invoice'))]) : _vm._e(), _vm._v(" "), ((_vm.isNumbered || _vm.isCreditNote) && (props.rec.is_creditnote === false) && !props.rec.is_expired && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec, false)
            }
          }
        }, [_vm._v("Send Email")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && props.rec.document_type_id === 1 && props.rec.is_expired && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec, true)
            }
          }
        }, [_vm._v("Send Email Reminder")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createCreditNote(props.rec)
            }
          }
        }, [_vm._v(_vm._s(_vm.getCancelCommand(props.rec)))]) : _vm._e()], 2)]
      }
    }])
  }), _vm._v(" "), _c('b-modal', {
    ref: "modalCreditNote",
    attrs: {
      "size": "lg",
      "title": "CreditNote"
    },
    on: {
      "ok": _vm.okCreditNote
    }
  }, [_c('b-form', {
    ref: "cnform",
    staticClass: "col-md-8 offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.cnRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Description",
      "field": "description",
      "rec": _vm.cnRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalLinkRegistrationFee",
    attrs: {
      "size": "lg",
      "title": "Link Registration Fee",
      "ok-title": "Link"
    },
    on: {
      "ok": _vm.okLinkRegistrationFee
    }
  }, [_c('b-form', {
    ref: "lrfform",
    staticClass: "col-md-8 offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    ref: "lfrOptionList",
    staticClass: "col-md-12",
    attrs: {
      "label": "Registration Fee",
      "field": "registration_id",
      "optionListApiUrl": '/invoices/choice/',
      "optionListApiDoUpdate": false,
      "rec": _vm.lrfRec,
      "isReadOnly": false,
      "vvalidate": "required",
      "validator": _vm.validator
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c7dd03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Invoice/Detail.vue
// module id = 714
// module chunks = 1